import { trustItems } from "@/mocks/categories";

export default function TrustBar() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="w-full px-6 md:px-10 py-6 md:py-8">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2.5">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${item.icon} text-sm text-primary-600`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-700 whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}